export class App {
  public static confs: any = {
    channelId: 'WEB',
    consumerName: 'web-app',
  };
}
